<template>
  <v-container class="pa-0">
    <v-dialog
      v-model="dialog"
      attach
      max-width="70%"
      class="ck-dialog"
    >
      <v-card
        v-if="dialog"
        class="ma-0 py-7"
      >
        <dynamic-content-form
          v-if="!dataLoading"
          :dynamic-content.sync="dynamicContent"
          :rules="rules"
          :isDialog="true"
          :title="dynamicContentData.id ? 'Edit Dynamic Content' : 'Add Dynamic Content'"
          @save="createDynamicContent"
          @cancel="onCancel"
        />
        <div
          v-if="dataLoading"
          class="text-center font-weight-medium"
        >
          Fetching dynamic content data...please wait.
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import { $dynamicContent } from '@/services'
  import DynamicContentForm from '@/views/content/dynamic_content/DynamicContentForm.vue'
  export default {
    name: 'DynamicContentDialog',
    components: {
      DynamicContentForm,
    },
    props: {
      dynamicContentData: {
        type: Object,
        default () {
          return {}
        },
      },
      dataLoading: {
        type: Boolean,
        default: false,
      },
      editorInstance: {
        type: Object,
        default () {
          return {}
        },
      },
    },
    data: () => ({
      dialog: false,
      dynamicContent: {
        name: '',
        contentFeedId: undefined,
        editor: '',
      },
      rules: [
        {
          ruleSegmentId: undefined,
          ruleContentFeedId: undefined,
          html: '',
        },
      ],
      contentPart: [],
    }),
    watch: {
      dynamicContentData () {
        if (this.dynamicContentData.id) {
          this.rules = []
          this.contentPart = []
          this.dynamicContent = this.dynamicContentData
          this.dynamicContent.editor = this.dynamicContentData.html
          this.dynamicContent.contentFeedId = this.dynamicContentData.content_feed_id
          this.dynamicContent.contentFeedName = this.dynamicContentData.content_feed_name
          if (this.dynamicContentData && this.dynamicContentData.content_parts.length > 0) {
            this.dynamicContentData.content_parts.forEach((item) => {
              const data = {
                id: item.id,
                ruleSegmentId: item.segment_id,
                ruleSegmentName: item.segment_name,
                ruleContentFeedId: item.content_feed_id,
                ruleContentFeedName: item.content_feed_name,
                html: item.html,
              }
              this.contentPart.push(data)
              this.rules.push(data)
            })
          }
        }
      },
    },
    methods: {
      /**
       * Method to open dialog for Dynamic Content.
       */
      openDialog () {
        this.dialog = true
      },
      /**
       * Used for on close dialog for Dynamic Content.
       */
      onCancel () {
        this.dynamicContent = {
          name: '',
          contentFeedId: '',
          editor: '',
        }
        this.rules = [{
          ruleSegmentId: '',
          ruleContentFeedId: '',
          html: '',
        }]
        this.dialog = false
      },
      /**
       * Create new dynamic content with required dataset
       */
      createDynamicContent (formData) {
        if (this.dynamicContent.id) {
          const data = this.updateFormData(formData)
          $dynamicContent.update(this.dynamicContent.id, data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }).then(response => {
            this.$store.commit('ui/snackbar', {
              message: 'Dynamic Content updated successfully',
              type: 'success',
            })
            this.onCancel()
          })
        } else {
          const data = this.addRuleFormData(formData)
          $dynamicContent.create(data, {
            headers: { 'Content-Type': 'multipart/form-data' },
          }).then((response) => {
            this.$store.commit('ui/snackbar', {
              message: 'Dynamic Content created successfully',
              type: 'success',
            })
            this.insertDynamicTag(this.dynamicContent.name)
            this.onCancel()
          })
        }
      },
      /**
       * Manage Rule data with respect to segment data
       */
      addRuleFormData (formData) {
        for (let i = 0; i < this.rules.length; i++) {
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][_destroy]`,
            false
          )
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][segment_id]`,
            this.rules[i].ruleSegmentId
          )

          this.rules[i].ruleContentFeedId && formData.append(
            `dynamic_content[content_parts_attributes][${i}][content_feed_id]`,
            this.rules[i].ruleContentFeedId
          )

          formData.append(
            `dynamic_content[content_parts_attributes][${i}][html]`,
            this.rules[i].html
          )
        }
        return formData
      },
      /**
       * Used for inject dynamic content tag in editor's HTML
       */
      insertDynamicTag (tagValue) {
        this.editorInstance.focus()
        this.editorInstance.fire('saveSnapshot')
        this.editorInstance.insertHtml(`{{dynamic_content.${tagValue}}}`)
        this.editorInstance.fire('saveSnapshot')
      },
      /**
       * Update Form data according to payload
       */
      updateFormData (formData) {
        const deletedRules = this.contentPart.filter(c => {
          return !this.rules.find(r => c.id === r.id)
        })
        for (let i = 0; i < this.rules.length; i++) {
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][_destroy]`,
            false
          )
          this.rules[i].id && formData.append(
            `dynamic_content[content_parts_attributes][${i}][id]`,
            this.rules[i].id
          )
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][segment_id]`,
            this.rules[i].ruleSegmentId
          )

          formData.append(
            `dynamic_content[content_parts_attributes][${i}][content_feed_id]`,
            this.rules[i].ruleContentFeedId || ''
          )

          formData.append(
            `dynamic_content[content_parts_attributes][${i}][html]`,
            this.rules[i].html
          )
        }
        // delete rule
        deletedRules.map((rule, index) => {
          const i = this.rules.length + index
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][_destroy]`,
            true
          )
          rule.id && formData.append(
            `dynamic_content[content_parts_attributes][${i}][id]`,
            rule.id
          )
          formData.append(
            `dynamic_content[content_parts_attributes][${i}][segment_id]`,
            rule.ruleSegmentId
          )
        })
        return formData
      },
    },
  }
</script>
